import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";

/**
 * Twinning band — slow crossfade between all live pair-heroes.
 * Auto-advances every 5s; hovering pauses; dots below let you jump.
 */
const PAIRS = [
  {
    key: "crazy-car",
    image: "/api/uploads/twinning/crazy-car-white/pair-hero-2.webp",
    alt: "Father and son wearing the Crazy Car twinning shirts on a wooden plinth",
    label: "Crazy Car pair · ₹2,099",
    deepLink: "/product/crazy-car-shirt-white",
  },
  {
    key: "busy-bee-family",
    image: "/api/uploads/community/grown-ups/family-bee.webp",
    alt: "Father and two sons wearing the Busy Bee shirts in mint, white and lilac",
    label: "Busy Bee family · ₹2,099",
    deepLink: "/product/busy-bee-shirt-mint",
  },
  {
    key: "busy-bee",
    image: "/api/uploads/twinning/busy-bee/pair-hero.webp",
    alt: "Father and two sons wearing the Busy Bee twinning shirts in a garden",
    label: "Busy Bee garden · ₹2,099",
    deepLink: "/product/busy-bee-shirt-mint",
  },
  {
    key: "crazy-car-original",
    image: "/api/uploads/twinning/crazy-car-white/pair-hero.webp",
    alt: "Father and son wearing the Crazy Car twinning shirts on a wooden plinth",
    label: "Crazy Car original · ₹2,099",
    deepLink: "/product/crazy-car-shirt-white",
  },
];

const TwinningBand = () => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((n) => (n + 1) % PAIRS.length), 5000);
    return () => clearInterval(t);
  }, [paused]);
  const cur = PAIRS[i];
  return (
    <section className="relative py-24" data-testid="twinning-band">
      <div className="hairline-t hairline-b py-20">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-5">
            <div className="nav-item mb-4">Twinning</div>
            <h3 className="serif text-4xl md:text-5xl leading-tight">
              Father, sons. On the same plinth.
            </h3>
            <p className="mt-6 text-ink/80 leading-relaxed max-w-[48ch]">
              Two pairs live now — Crazy Car and Busy Bee. Same weave, same embroidery, adult scale
              beside child scale. Mother &amp; daughter, coming soon — the fabric is on the table.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-6">
              <Link to="/twinning" className="btn-ink" data-testid="twinning-cta">Explore the pairs</Link>
              <Link to={cur.deepLink} className="crimson-link nav-item !text-[12px]" data-testid={`twinning-deep-${cur.key}`}>
                {cur.label} →
              </Link>
            </div>
            <div className="mt-8 flex gap-2" data-testid="twinning-dots">
              {PAIRS.map((p, idx) => (
                <button
                  key={p.key}
                  onClick={() => setI(idx)}
                  aria-label={`View ${p.key} pair`}
                  className={`h-1 transition-all ${idx === i ? "w-10 bg-ink" : "w-6 bg-ink/25 hover:bg-ink/60"}`}
                  data-testid={`twinning-dot-${p.key}`}
                />
              ))}
            </div>
          </div>
          <div
            className="md:col-span-7 relative"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
          >
            <div className="relative aspect-[4/5] overflow-hidden bg-sand">
              {PAIRS.map((p, idx) => (
                <img
                  key={p.key}
                  src={imgUrl(p.image)}
                  alt={p.alt}
                  className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
                  style={{ opacity: idx === i ? 1 : 0 }}
                  data-testid={`twinning-pair-${p.key}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwinningBand;
